import Arrow from "../../assets/images/icons/Icon-Freccia-menu.svg";
import { Link } from "react-router-dom";
import AppText from "../_shared/components/AppText";
import splashScreen from "../../assets/splash.png";
import { useState } from "react";

function Home(props) {
  const { setSplash } = props;
  return (
    <img
      onClick={() => setSplash(false)}
      src={splashScreen}
      style={{
        height: "100vh",
        display: "grid",
        placeItems: "center",
        margin: "auto",
        cursor: "pointer",
        backgroundColor: "white",
        width: "100vw",
        objectFit: "contain",
      }}
      alt=""
    ></img>
  );
}

export default Home;
